import Model, { attr } from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

// Proto: people.Policy.
export default class Policy extends Model {
  declare [Type]: 'policy';

  // version identifies the version of the policy, for display and reference.
  // Bumping the version of an existing policy does not require re-acceptance;
  // publishing a new policy record (new id) does. See utils/policies.
  @attr('string', { defaultValue: '' })
  declare version: string;

  // changes describes what changed in the current version of the policy.
  @attr({ defaultValue: () => [] })
  declare changes: string[];

  // createTime is when the policy was created, in seconds from the epoch. Used
  // to determine the most recently published policy.
  @attr('number')
  declare createTime: number | undefined;

  // jurisdiction is the jurisdiction the policy pertains to
  @attr('number', { defaultValue: 0 })
  declare jurisdiction: EnumValue<typeof Jurisdiction> | 0;
}
